@if (isVisible()) {
  <div class="relative flex items-center" (keydown.escape)="closePopover()">
    @if (step() === ListExportStep.EXPORTING) {
      <div
        class="flex items-center gap-4 h-11 px-4 rounded-lg border-[1.5px] border-primary-purple-light bg-primary-purple-light-2 shadow-md"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="percentage()"
        [attr.aria-label]="literalService.get('listExport.exporting', true)"
      >
        <img [src]="images.downloadList" alt="" aria-hidden="true" class="w-6 h-6 filter-primary-purple-light" />
        <span class="relative w-28 h-2 rounded-full border border-neutrals-grey-03 bg-white overflow-hidden" aria-hidden="true">
          <span
            class="absolute inset-y-0 left-0 rounded-full bg-primary-purple-light motion-safe:transition-[width] motion-safe:duration-300"
            [style.width.%]="percentage()"
          ></span>
        </span>
        <span class="min-w-10 text-base text-primary-purple-light tabular-nums">{{ percentage() }}%</span>
      </div>
    } @else {
      <button
        type="button"
        class="flex items-center justify-center w-11 h-11 rounded-full! border-[1.5px] hover:bg-neutrals-grey-01 focus-visible:outline-2! focus-visible:outline-offset-2! focus-visible:outline-primary-purple! motion-safe:transition-colors"
        [class.border-transparent!]="!isPopoverOpen()"
        [class.border-primary-purple-light!]="isPopoverOpen()"
        [class.bg-primary-purple-light-2!]="isPopoverOpen()"
        [attr.aria-label]="literalService.get('listExport.tooltip', true)"
        [attr.aria-expanded]="isPopoverOpen()"
        aria-controls="list-export-popover"
        aria-haspopup="dialog"
        [tooltip]="isPopoverOpen() ? '' : literalService.get('listExport.tooltip', true)"
        [position]="TooltipPosition.BELOW"
        (click)="togglePopover()"
      >
        <img
          [src]="images.downloadList"
          alt=""
          aria-hidden="true"
          class="w-6 h-6"
          [class.filter-primary-purple-light]="isPopoverOpen()"
        />
      </button>
    }

    @if (isPopoverOpen()) {
      <div
        id="list-export-popover"
        class="absolute left-1/2 -translate-x-1/2 top-14 z-50 p-5 rounded-2xl border border-neutrals-grey-02 bg-white shadow-lg text-neutrals-grey-06"
        role="dialog"
        [attr.aria-label]="literalService.get('listExport.title', true)"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
      >
        @if (formattedRowCounts(); as rowCounts) {
          <fieldset class="flex flex-col gap-4">
            <legend class="sr-only">{{ literalService.get('listExport.title', true) }}</legend>
            <label for="list-export-all" class="flex items-center gap-3 cursor-pointer text-base whitespace-nowrap">
              <input
                id="list-export-all"
                type="radio"
                name="list-export-scope"
                class="radio radio-primary"
                [checked]="scope() === ListExportScope.ALL"
                (change)="scope.set(ListExportScope.ALL)"
              />
              <span>
                {{ literalService.get('listExport.all', true) }}
                <strong class="font-semibold">{{ literalService.get('listExport.rows', false, { rows: rowCounts.allRows }) }}</strong>
              </span>
            </label>
            <label for="list-export-visible" class="flex items-center gap-3 cursor-pointer text-base whitespace-nowrap">
              <input
                id="list-export-visible"
                type="radio"
                name="list-export-scope"
                class="radio radio-primary"
                [checked]="scope() === ListExportScope.VISIBLE"
                (change)="scope.set(ListExportScope.VISIBLE)"
              />
              <span>
                {{ literalService.get('listExport.visible', true) }}
                <strong class="font-semibold">{{ literalService.get('listExport.rows', false, { rows: rowCounts.visibleRows }) }}</strong>
              </span>
            </label>
          </fieldset>
          @if (!selectedRows()) {
            <p class="mt-3 text-sm text-neutrals-grey-05" aria-live="polite">
              {{ literalService.get('listExport.empty', true) }}
            </p>
          }
          <div class="flex gap-3 mt-5">
            <button
              type="button"
              class="secondary h-11 px-5 rounded-lg! border-[1.5px] text-base! font-semibold!"
              (click)="closePopover()"
            >
              {{ literalService.get('cancel', true) }}
            </button>
            <button
              type="button"
              class="primary flex items-center justify-center gap-2 h-11 px-5 rounded-lg! border-[1.5px] text-base! font-semibold!"
              [disabled]="!selectedRows()"
              (click)="startExport()"
            >
              <img [src]="images.download" alt="" aria-hidden="true" class="w-5 h-5 filter-neutrals-white" />
              {{ literalService.get('listExport.download', true) }}
            </button>
          </div>
        } @else {
          <p class="text-base whitespace-nowrap" aria-live="polite" aria-busy="true">
            {{ literalService.get('listExport.counting', true) }}
          </p>
        }
      </div>
    }
  </div>
}
